export default __webpack_public_path__ + "static/media/slider.9121da0b.mp3";